const topics = [
  { label: '最新电影', icon: 'ri-movie-2-line', count: '2.3万', trend: 'up' },
  { label: '热播剧集', icon: 'ri-tv-2-line', count: '5.8万', trend: 'up' },
  { label: '综艺推荐', icon: 'ri-emotion-laugh-line', count: '1.9万', trend: 'up' },
  { label: '动漫精选', icon: 'ri-ghost-smile-line', count: '8.6千', trend: 'up' },
  { label: '纪录片', icon: 'ri-earth-line', count: '6.2千', trend: 'stable' },
  { label: '国产剧', icon: 'ri-flag-2-line', count: '3.4万', trend: 'up' },
  { label: '韩剧专区', icon: 'ri-heart-2-line', count: '2.7万', trend: 'up' },
  { label: '美剧精选', icon: 'ri-star-line', count: '1.5万', trend: 'stable' },
  { label: '日剧专题', icon: 'ri-sun-line', count: '1.1万', trend: 'up' },
  { label: '动作大片', icon: 'ri-fire-line', count: '4.2万', trend: 'up' },
  { label: '喜剧合辑', icon: 'ri-emotion-happy-line', count: '2.8万', trend: 'stable' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm font-medium text-accent-600 uppercase tracking-wide mb-2">热门话题</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">大家都在关注的热门影视话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer group"
            >
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200/60 group-hover:bg-primary-100/60 transition-colors">
                <i className={`${topic.icon} text-xs text-foreground-500 group-hover:text-primary-500`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                {topic.label}
              </span>
              <span className="flex items-center gap-0.5 text-xs text-foreground-400">
                {topic.trend === 'up' && <i className="ri-arrow-up-line text-[10px] text-accent-500"></i>}
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}